var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnkonwOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b30u7xuixa",
    cx: 8,
    cy: 8,
    r: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qfu8jf6qfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b30u7xuixa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FE5353",
    xlinkHref: "#b30u7xuixa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.218 12.526a.227.227 0 0 0-.192.128.246.246 0 0 0 .01.237.224.224 0 0 0 .203.109h9.53a.225.225 0 0 0 .2-.118.246.246 0 0 0 0-.239.225.225 0 0 0-.2-.117H3.219z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.64,
    mask: "url(#qfu8jf6qfb)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#qfu8jf6qfb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-2 226.607 -17.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.264.956.692.007L2.2 2.68l6.714.24c1.234.048 2.2.09 2.399.11.634.065 1.402.57 1.657.727.28.174.206.641-.526.747l-.206.026c-.618.067-1.79.116-3.568-.019L5.398 6.275l-.59-.22-.138-.602.27.075.168.174 1.385-1.417-.232-.03-1.481-.21C2.29 3.679.792 3.387.792 3.387L.264.956zm3.4-.78.192.087.263.55 3.19 1.83-1.958-.072-1.588-1.54-.1-.855z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.97 4.57h.817v-.204l-.816.021z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M10.379 4.569v.254"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 10.398,
    cy: 4.886,
    r: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.396 6.735V5.228c.483-.02.865-.125 1.145-.316s.421-.491.421-.9v-.136c0-.324-.088-.563-.264-.72-.176-.155-.41-.232-.702-.232-.31 0-.561.095-.752.286a1.51 1.51 0 0 0-.394.725L8 3.565c.054-.2.136-.397.246-.588a1.95 1.95 0 0 1 .412-.5 1.96 1.96 0 0 1 .586-.346C9.47 2.044 9.733 2 10.03 2c.299 0 .569.045.81.136.242.09.45.219.622.384.173.165.306.366.398.603.093.236.139.497.139.783a1.898 1.898 0 0 1-.519 1.361 2.02 2.02 0 0 1-.532.398c-.2.104-.405.175-.613.214v.856h-.94zM9.888 9c-.274 0-.468-.062-.582-.185a.662.662 0 0 1-.17-.466v-.234c0-.188.057-.343.17-.466.114-.124.308-.185.582-.185.275 0 .468.061.582.185.113.123.17.278.17.466v.234a.662.662 0 0 1-.17.466c-.114.123-.307.185-.582.185z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#qfu8jf6qfb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnkonwOp);
export default __webpack_public_path__ + "static/media/unkonw_op.49154f1de216fb5bccbdcabcb45ad452.svg";
export { ForwardRef as ReactComponent };